/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ChatMessage } from './ChatMessage';
import {
    ChatMessageFromJSON,
    ChatMessageFromJSONTyped,
    ChatMessageToJSON,
} from './ChatMessage';
import type { StudentContext } from './StudentContext';
import {
    StudentContextFromJSON,
    StudentContextFromJSONTyped,
    StudentContextToJSON,
} from './StudentContext';

/**
 * 
 * @export
 * @interface StudentSummaryRequest
 */
export interface StudentSummaryRequest {
    /**
     * 
     * @type {Array<ChatMessage>}
     * @memberof StudentSummaryRequest
     */
    conversation: Array<ChatMessage>;
    /**
     * 
     * @type {StudentContext}
     * @memberof StudentSummaryRequest
     */
    studentContext: StudentContext;
    /**
     * 
     * @type {string}
     * @memberof StudentSummaryRequest
     */
    engineChoice: string;
}

/**
 * Check if a given object implements the StudentSummaryRequest interface.
 */
export function instanceOfStudentSummaryRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "conversation" in value;
    isInstance = isInstance && "studentContext" in value;
    isInstance = isInstance && "engineChoice" in value;

    return isInstance;
}

export function StudentSummaryRequestFromJSON(json: any): StudentSummaryRequest {
    return StudentSummaryRequestFromJSONTyped(json, false);
}

export function StudentSummaryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StudentSummaryRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'conversation': ((json['conversation'] as Array<any>).map(ChatMessageFromJSON)),
        'studentContext': StudentContextFromJSON(json['studentContext']),
        'engineChoice': json['engineChoice'],
    };
}

export function StudentSummaryRequestToJSON(value?: StudentSummaryRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'conversation': ((value.conversation as Array<any>).map(ChatMessageToJSON)),
        'studentContext': StudentContextToJSON(value.studentContext),
        'engineChoice': value.engineChoice,
    };
}

